import Vue from 'vue';
import gql from 'graphql-tag';

export default {
    namespaced: true,
    state: {
        shippingTypes: [],
        currentShippingType: null,
    },
    mutations: {
        setShippingTypes(state, shippingTypes) {
            state.shippingTypes = shippingTypes;
        },
        setCurrentShippingType(state, shippingType) {
            Vue.$basket.addBasketOption({
                key: 'shippingType',
                value: shippingType,
            });

            state.currentShippingType = shippingType;
        },
        removeCurrentShippingType(state) {
            Vue.$basket.removeBasketOption({
                key: 'shippingType',
            });

            state.currentShippingType = null;
        },
    },
    getters: {
        getShippingTypes: state => state.shippingTypes,
        getCurrentShippingType: state => state.currentShippingType,
    },
    actions: {
        uploadFile(action, { file }) {
            return Vue.$graphql
                .mutate({
                    mutation: gql`
                        mutation uploadFile($file: Upload!) {
                            uploadFile(file: $file) {
                                url
                                success
                                error
                            }
                        }
                    `,
                    variables: {
                        file,
                    },
                })
                .then(r => {
                    return r.data.uploadFile;
                });
        },
        async queryShippingTypes({ commit }, payload) {
            let country = Vue.$country.getCountry();
            if (payload !== undefined && payload.country !== undefined) {
                country = payload.country;
            }

            return Vue.$graphql
                .query({
                    query: gql`
                        query shippingTypes($country: String, $basket: BasketInput) {
                            shippingTypes(country: $country, basket: $basket) {
                                id
                                name
                                is_default
                            }
                        }
                    `,
                    variables: {
                        country,
                        currency: Vue.$currency.getSelected(),
                        basket: {
                            ...Vue.$basket.getBasket(),
                            items: Object.values(Vue.$basket.getBasket().items),
                        },
                    },
                })
                .then(r => {
                    commit('setShippingTypes', r.data.shippingTypes);
                    let currentShippingType = r.data.shippingTypes.find(el => {
                        return el.is_default;
                    });

                    if (!currentShippingType) {
                        currentShippingType = r.data.shippingTypes[0];
                    }

                    commit('setCurrentShippingType', currentShippingType.id);

                    return true;
                });
        },
    },
};
